import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=73701a06&scoped=true&"
import script from "./TakePhoto.vue?vue&type=script&lang=ts&"
export * from "./TakePhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73701a06",
  null
  
)

export default component.exports